import React, { useState } from "react";
import { FontFa } from "../../../components";
import "./sidebar.scss";
import type { MenuProps } from "antd";
import { Menu } from "antd";
import Sider from "antd/lib/layout/Sider";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../AppRoutes";
import { useSearchParams } from "../../../hook/use-search-params";
import { AiOutlineDesktop } from "react-icons/ai";

type MenuItem = Required<MenuProps>["items"][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: "group",
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
  } as MenuItem;
}

const items: MenuItem[] = [
  getItem(" Cấu hình danh sách nhân viên", "1", <FontFa name="faUser" color="#00a9c4" />),
  getItem("Cấu hình người phê duyệt", "2", <FontFa name="faUserCheck" color="#00a9c4" />),

  getItem("Phòng công nghệ thông tin", "sub1", <AiOutlineDesktop color="#00a9c4" />, [
    getItem("1. Xoá tài khoản", "3"),
    getItem("2. Cấp code Amadeus", "4"),
    getItem("3. Cấp quyền sử dụng chương trình", "5"),
    getItem("4. Sửa chữa CNTT", "6"),
    getItem("5. Nhu cấp vật tư, CCDC CNTT", "7"),
  ]),

  getItem("Văn phòng công ty", "sub2", <FontFa name="faBuilding" color="#00a9c4" />, [
    getItem("1. Cấp/hoàn vé công tác", "8"),
    getItem("2. Cấp thẻ KSAN cho nội bộ VIAGS", "9"),
    getItem("3. Cấp thẻ KSAN cho đơn vị ngoài", "10"),
    getItem("4. Cấp giấy phép KSAN cho phương tiện VIAGS", "11"),
    getItem("5. Cấp giấy phép KSAN cho đơn vị ngoài", "12"),
    getItem("6. Sử dụng xe công vụ", "13"),
  ]),
  getItem("Đơn xin nghỉ phép", "21", <FontFa name="faUsers" color="#00a9c4" />),
  getItem("Phân quyền", "14", <FontFa name="faCog" color="#00a9c4" />),
];

const getopenKey = (configId: string): string => {
  const id = +configId;
  if (!configId) return "";
  if (id <= 2) return "";
  else {
    const parentId: any = items.find((e: any) => e.children?.findIndex((e: any) => e.key === configId) > -1);
    return parentId ? parentId.key : "";
  }
};

const SideBar: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const history = useHistory();
  const { searchParams } = useSearchParams();
  const [configId, setConfigId] = useState(searchParams.get("configId") || "1");
  const openKey = getopenKey(configId);

  const handleMenuSelected: MenuProps["onSelect"] = (event) => {
    setConfigId(event.key);
    history.push({ pathname: Routes.ConfigProcedure.path, search: `configId=${event.key}&tab=1` });
  };

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
      width={"400px"}
      collapsedWidth={76}
    >
      <Menu
        theme="light"
        defaultOpenKeys={[openKey]}
        selectedKeys={[configId]}
        defaultSelectedKeys={["1"]}
        mode="inline"
        items={items}
        onSelect={handleMenuSelected}
      />
    </Sider>
  );
};

export default SideBar;
